import { FeatureAppTrackingManager, FilterList } from "../types/tagging";
import { getDefaultTrackingEvent } from "../hooks/use-tracking-manager";
import { mapVehiclesToVehiclesList, mapVehicleToConfiguration } from "../utils/general";
import { Vehicle } from "../types/vehicle";

export const onVWBasicPageLoad = (trackingManager: FeatureAppTrackingManager) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: "MiniMOFA page load",
    eventAction: "VWBasic_GenericFeatureApp_Load"
  }

  trackingManager.trackMaintenanceGlobalEvent(
    'VWBasic_GenericFeatureApp_Load',
    customEvent,
  )
}

export const onVWBasicFilterSelect = (
  trackingManager: FeatureAppTrackingManager,
  tabLabel: string,
  vehicleNames: string[]
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: "MiniMOFA filter select",
    eventAction: "VWBasic_FilterSelect_Click"
  }

  customEvent.filter = {
    ...customEvent.filter,
    type: "single_value",
    name: "Vehicle Category",
    values: [tabLabel],
    numberOfResults: vehicleNames.length || 0
  }

  trackingManager.trackMaintenanceGlobalEvent(
    'VWBasic_FilterSelect_Click',
    customEvent,
  )
}

const MANUFACTURER_NAME = "Volkswagen";

const FILTER_ABBREVIATIONS = {
  bodyType: "BT",
  model: "CG",
  manufacturer: "MF",
} as const;

export type ActiveFilters = Partial<Record<keyof typeof FILTER_ABBREVIATIONS, string[]>>;

/**
 * Build the filter.filterlist array with one entry per active filter group
 */
export const buildFilterList = (activeFilters: ActiveFilters): FilterList[] => {
  return (Object.keys(FILTER_ABBREVIATIONS) as Array<keyof typeof FILTER_ABBREVIATIONS>)
    .map((filterKey) => ({
      type: "multi_value" as const,
      name: FILTER_ABBREVIATIONS[filterKey],
      values: (activeFilters[filterKey] || []).filter(Boolean),
    }))
    .filter((filterGroup) => filterGroup.values.length > 0);
}

export const onVWBasicFilterResultLoad = (
  trackingManager: FeatureAppTrackingManager,
  tabName: string,
  vehicles: Vehicle[]
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: "MiniMOFA filter result load",
    eventAction: "VWBasic_FilterResult_Load"
  }

  customEvent.filter = {
    ...customEvent.filter,
    type: "single_value",
    name: tabName,
    numberOfResults: vehicles.length || 0,
    filterlist: buildFilterList({ bodyType: [tabName], manufacturer: [MANUFACTURER_NAME] })
  }

  customEvent.configuration = {
    ...customEvent.configuration,
    vehicleList: mapVehiclesToVehiclesList(vehicles)
  }

  trackingManager.trackMaintenanceGlobalEvent(
    'VWBasic_FilterResult_Load',
    customEvent,
  )
}

export const onVWBasicLinkClick = (
  trackingManager: FeatureAppTrackingManager,
  linkURL: string,
  linkName: string,
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId: "MiniMOFA link click",
    eventAction: "VWBasic_Link_Click"
  }

  customEvent.link = {
    ...customEvent.link,
    name: linkName,
    url: linkURL,
    newTab: true
  }

  trackingManager.trackMaintenanceGlobalEvent(
    'VWBasic_Link_Click',
    customEvent,
  )
}

export const onVWBasicVehicleSelectClick = (
  trackingManager: FeatureAppTrackingManager,
  linkURL: string,
  linkName: string,
  vehicle: Vehicle,
  contentId: string
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId,
    eventAction: "VWBasic_VehicleSelect_Click"
  }

  customEvent.link = {
    ...customEvent.link,
    name: linkName,
    url: linkURL,
    newTab: true
  }

  customEvent.configuration = {
    ...customEvent.configuration,
    ...mapVehicleToConfiguration(vehicle)
  }

  trackingManager.trackMaintenanceGlobalEvent('VWBasic_VehicleSelect_Click', customEvent);
}

export const onVWBasicVehicleButtonClick = (
  trackingManager: FeatureAppTrackingManager,
  linkURL: string,
  linkName: string,
  vehicle: any,
  contentId: string
) => {
  let customEvent = getDefaultTrackingEvent();

  customEvent.eventInfo = {
    ...customEvent.eventInfo,
    contentId,
    eventAction: "VWBasic_VehicleButton_Click"
  }

  customEvent.link = {
    ...customEvent.link,
    name: linkName,
    url: linkURL,
    newTab: true
  }

  customEvent.configuration = {
    ...customEvent.configuration,
    ...mapVehicleToConfiguration(vehicle)
  }

  trackingManager.trackMaintenanceGlobalEvent('VWBasic_VehicleButton_Click', customEvent);
}